import * as React from "react";

export type BoardProperties = {
  holeWidth: number;
  holeHeight: number;
  boardWidth: number;
  boardHeight: number;
  highlightedHoles: {
    "0": number[];
    "1": number[];
  };
};
export type ContextType = {
  boardProperties: BoardProperties;
  setBoardProperties?: (boardProperties: BoardProperties) => void;
};
export const initialBoardProperties: BoardProperties = {
  holeWidth: 72,
  holeHeight: 56,
  boardWidth: 688,
  boardHeight: 284,
  highlightedHoles: {
    "0": [] as number[],
    "1": [] as number[]
  }
};
const initialContextValue: ContextType = {
  boardProperties: initialBoardProperties
};
const BoardPropertiesContext: React.Context<ContextType> = React.createContext<ContextType>(initialContextValue);
export default BoardPropertiesContext;
